import { Icon as IconifyIcon } from '@iconify/vue/dist/offline'

import { defineComponent, h } from 'vue'

// Iconify Icon在Vue里在线使用（用于外网环境）
export default defineComponent({
	name: 'IconifyIconOnline',
	components: { IconifyIcon },
	props: {
		icon: {
			type: String,
			default: '',
		},
	},
	render() {
		const attrs = this.$attrs
		const iconName = `${this.icon}`.replace(':', '/')
		return h(
			IconifyIcon,
			{
				icon: iconName,
				'aria-hidden': false,
				style: attrs?.style ? Object.assign(attrs.style, { outline: 'none' }) : { outline: 'none' },
				...attrs,
			},
			{
				default: () => [],
			}
		)
	},
})
